import { translate } from '@/domains/core/localization/translate';
export const DESCRIPTION_FILE_KEY = 'technicalSheetPdf';
export const SAFETY_FILE_KEY = 'safetyPDF';
export const docFileNames = translate({
  "technicalSheetPdf": "Technical Sheet",
  "productInformationPdf": "Product Information Sheet",
  "productInstructionsPdf": "Product Instructions",
  "repairabilityIndexPdf": "Repairability Index Sheet",
  "safetyPDF": "Product Safety PDF"
});
export const {
  descriptionPanelDownloadDocumentTitle,
  downloadTheDocuments,
  downloadAllTheDocuments,
  allDocuments,
  documentByDocument
} = translate({
  "descriptionPanelDownloadDocumentTitle": "Documents to download",
  "downloadTheDocuments": "Download the documents",
  "downloadAllTheDocuments": "Download all documents",
  "allDocuments": "All documents",
  "documentByDocument": "Document by document"
});